/**
 * @packageDocumentation
 * @module Utils
 */
/**
 * Helper to open browser window
 *
 * @param url - string with url to open
 * @param target - string with target window '_blank' for a new window
 * @param features - string with features like height and width
 *
 * @packageDocumentation
 * @module utils
 */
var OpenWindow = function (url, target, features) { return window.open(url, target, features); };
export default OpenWindow;
//# sourceMappingURL=OpenWindow.js.map